import {action, observable} from 'mobx';

export default class PromotionStore {
    @observable openingPromotion = undefined;

    @action updateOpeningPromotion(openingPromotion) {
        this.openingPromotion = openingPromotion
    }
}


// WEBPACK FOOTER //
// ./src/app/stores/PromotionStore.js